import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

export function trackCommunityTemplateSearched(input: { search: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.Community,
    props: {
      action: SegmentActionName.CommunityTemplateSearched,
      search: input.search,
    },
  });

  // V2 — community_searched
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.CommunitySearched,
    props: {
      query: input.search,
    },
  });
}
